import * as React from 'react';
import RecieverListRow from './CommunicationRecieverListRow';
import { Translate } from '../../../../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import { IRecipient } from '../Types';

interface IProps {
    items: string[];
}

const CommunicationRecieverList = (props: IProps) => {
    return (
        <Table responsive>
            <thead>
                <tr className="table_header">
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-communication-details/table-headers/recipients'
                        )}
                    </th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((i: string, index: number) => {
                    return <RecieverListRow item={i} key={index} />;
                })}
            </tbody>
        </Table>
    );
};

export default CommunicationRecieverList;
